import React, { useEffect, useState } from "react";
import { IonSpinner } from "@ionic/react";
import { useContext } from "react";
import { PortalContext } from "../../../context/Provider";
import { regexNumero } from "../../../../global/utils/expresionesRegulares";
import { GlobalContext } from "../../../../global/context/Provider";
import { isNativeMobile } from "../../../../global/utils/platformDetector";
import HidePassIcon from "../../../assets/images/generico/HidePassIcon";
import ShowPassIcon from "../../../assets/images/generico/ShowPassIcon";
import InputV1 from "../../Genericos/InputV1/InputV1";
import BiometricButton from "../BiometricButton/BiometricButton";
import SocialDivContainer from "../../Genericos/SocialDivContainer/SocialDivContainer";
import SeparadorLogin from "../../Genericos/SeparadorLogin/SeparadorLogin";
import LoginIcon from "../../../assets/images/generico/LoginIcon";
import { useWebChat } from "../../Genericos/WebChatWidget/WebChatProvider";
import {
  ChatBubbleIcon,
  CloseIcon,
  UnreadBadge,
} from "../../Genericos/WebChatWidget/WebChatIcons";
import "./LoginBox.css";

const LoginBox = ({
  form,
  error,
  onChange,
  onSubmit,
  loginFormValid,
  loading,
  onClickSocialHandler,
  onClickRegister,
  onClickChangePassword,
  responseFacebook,
  biometricAvailable = false,
  biometricEnabled = false,
  biometricLoading = false,
  biometryTypeName = "Huella Digital",
  lastBiometricUser = null,
  onBiometricLogin,
}) => {
  const { configState } = useContext(GlobalContext);
  const { registroState, modalState } = useContext(PortalContext);
  const [passwordShown, setPasswordShown] = useState(false);
  const [versionApk, setVersionApk] = useState(false);
  const isMobile = isNativeMobile();
  // Chat interno DIM (instancia unica en WebChatProvider): si config.json trae "webchat"
  // la pestaña de la esquina abre el chat en vez del link de WhatsApp.
  const {
    enabled: chatEnabled,
    open: chatOpen,
    unread: chatUnread,
    toggleChat,
  } = useWebChat();
  const showPassword = () => {
    setPasswordShown(true);
  };
  const hidePassword = () => {
    setPasswordShown(false);
  };

  const onKeyPress = (e) => {
    if (!regexNumero.test(e.key)) {
      e.preventDefault();
    }
    if (e.target.name === "password") {
      if (e.key === "Enter") {
        if (loginFormValid) {
          onSubmit(form);
        }
      }
    } else if (e.key === "Enter") {
      document.getElementsByName("password")[0].focus();
    }
  };

  useEffect(() => {
    if (configState.config.data) {
      setVersionApk(configState.config.data.version);
    }
  }, [configState.config.data]);

  let config = localStorage.getItem("config");
  let parsedConfig = config ? JSON.parse(config) : {};
  const noSocialLogin = !parsedConfig?.opcLoginGoogle && !parsedConfig?.opcLoginApple;

  // Variantes: "loginBox--noSocial-A" (minimal), "loginBox--noSocial-B" (moderada), "loginBox--noSocial-C" (completa)
  const noSocialVariant = "loginBox--noSocial-C";
  const loginBoxClass = `loginBox ${noSocialLogin ? `loginBox--noSocial ${noSocialVariant}` : ""}`;

  return (
    <React.Fragment>
      <div className="ptur-loginBoxImg">
        <img
          style={{ marginBottom: 25, width: 126, height: 52 }}
          src="../../../../assets/images/empresa/IsoLogo.png"
          alt="logo"
        ></img>
      </div>
      <div className={loginBoxClass}>
        {parsedConfig?.opcBot !== false &&
          (chatEnabled ? (
            <button
              type="button"
              className={`loginBox-corner-tab loginBox-corner-tab--chat${
                chatOpen ? " is-open" : ""
              }`}
              onClick={toggleChat}
              aria-label={chatOpen ? "Cerrar chat de ayuda" : "Abrir chat de ayuda"}
              aria-expanded={chatOpen}
            >
              {chatOpen ? <CloseIcon /> : <ChatBubbleIcon />}
              {!chatOpen && (
                <UnreadBadge count={chatUnread} className="loginBox-corner-tab-badge" />
              )}
            </button>
          ) : (
            <a
              href="https://wa.me/5491166485555"
              target="_blank"
              rel="noopener noreferrer"
              className="loginBox-corner-tab loginBox-corner-tab--whatsapp"
              aria-label="Contactar por WhatsApp"
            >
              <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
              </svg>
            </a>
          ))}
        {noSocialLogin ? (
          <>
            <span className="rb32b c-latex10 loginBox-title">Bienvenido</span>
            <h2 className="rb18m c-grey45 loginBox-subtitle">
              Ingresá con tu DNI y contraseña
            </h2>
            <div className="loginBox--noSocial-divider" />
          </>
        ) : (
          <>
            <span className="rb32b c-latex10">Hola !</span>
            <h2 className="rb18m c-grey45">
              Iniciá sesión o{" "}
              <a className="c-latex30 pointer" onClick={onClickRegister}>
                <u>creá una cuenta</u>
              </a>
            </h2>
            <SocialDivContainer
              onClickHandler={onClickSocialHandler}
              responseFacebook={responseFacebook}
            />
            <SeparadorLogin texto={"o ingresá con tu DNI"} />
          </>
        )}

        {isMobile && biometricAvailable && biometricEnabled && (
          <BiometricButton
            onClick={onBiometricLogin}
            loading={biometricLoading}
            disabled={loading}
            biometryTypeName={biometryTypeName}
            lastUser={lastBiometricUser}
          />
        )}

        <div className="ptur-loginDivMarginTop"></div>
        {Array.isArray(form) &&
          form?.map((item, index) => {
            return (
              <React.Fragment key={index}>
                <InputV1
                  inputType={item.inputType}
                  name={item.name}
                  headerStr={item.headerStr}
                  placeholderText={item.placeholderText}
                  linkStr={item.linkStr}
                  errorStr={modalState.modal.show ? "" : item.errorStr}
                  onChange={onChange}
                  onKeyPress={onKeyPress}
                  onClickChangePassword={onClickChangePassword}
                  value={item.value}
                  className={
                    passwordShown && item.name === "password"
                      ? item.className + " inputNumericShow"
                      : item.name === "nro_documento"
                      ? item.className
                      : item.className + " inputNumeric"
                  }
                  maxLength={item.maxLength}
                  error={error}
                  checkError={
                    modalState.modal.show
                      ? ""
                      : registroState.registro.listError[item.name]
                  }
                  isRequired={item.isRequired}
                  inputMode={item.inputMode}
                  pattern={item.pattern}
                  desactivado={modalState.modal.show}
                />
                {item.name === "password" ? (
                  <>
                    {passwordShown === false ? (
                      <>
                        <button
                          className="ptur-loginBox-show-hideBtn"
                          onClick={() => showPassword()}
                        >
                          <HidePassIcon color="var(--color-latex30)" />
                        </button>
                      </>
                    ) : (
                      <>
                        <button
                          className="ptur-loginBox-show-hideBtn"
                          onClick={() => hidePassword()}
                        >
                          <ShowPassIcon color="var(--color-latex30)" />
                        </button>
                      </>
                    )}
                  </>
                ) : (
                  ""
                )}
              </React.Fragment>
            );
          })}
        <div className="ptur-loginDivMarginTop">
          <button
            className={`${
              loginFormValid ? "bgc-primary cursor:pointer " : "bgc-disabled"
            } c-white ptur-buttonLogin`}
            disabled={!loginFormValid || loading}
            onClick={onSubmit}
          >
            <LoginIcon />
            <span
              style={{ paddingLeft: 8, verticalAlign: "middle" }}
              className="rb18m"
            >
              {loading ? "Ingresando" : "Ingresar al Portal"}
            </span>
            {loading ? (
              <span className="spinner">
                <IonSpinner name="lines" />
              </span>
            ) : (
              ""
            )}
          </button>
        </div>
        {noSocialLogin && (
          <div className="ptur-loginDivMarginTop">
            <button
              className="ptur-buttonRegister"
              onClick={onClickRegister}
            >
              <span className="rb18m">Crear una cuenta</span>
            </button>
          </div>
        )}
        <div className="ptur-loginBox-versionPortal">
          <span className="c-grey65 rb12m">{versionApk}</span>
        </div>
      </div>
    </React.Fragment>
  );
};

export default LoginBox;
